<div
	gdColumns="repeat(auto-fill, minmax(180px, 1fr))"
	gdGap="10px"
	[formGroup]="form"
>
	<mat-form-field>
		<rpshared-currency-input
			placeholder="PW1 Rate"
			formControlName="pw1Rate"
		>
		</rpshared-currency-input>
		<mat-error *ngIf="form.get('pw1Rate').hasError('isNotNumeric')">
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('pw1Rate').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			placeholder="PW2 Rate"
			formControlName="pw2Rate"
		>
		</rpshared-currency-input>
		<mat-error *ngIf="form.get('pw2Rate').hasError('isNotNumeric')">
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('pw2Rate').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			placeholder="PW3 Rate"
			formControlName="pw3Rate"
		>
		</rpshared-currency-input>
		<mat-error *ngIf="form.get('pw3Rate').hasError('isNotNumeric')">
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('pw3Rate').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			placeholder="PW1 Night Shift Rate"
			formControlName="pw1NightShiftRate"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="form.get('pw1NightShiftRate').hasError('isNotNumeric')"
		>
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('pw1NightShiftRate').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			placeholder="PW2 Night Shift Rate"
			formControlName="pw2NightShiftRate"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="form.get('pw2NightShiftRate').hasError('isNotNumeric')"
		>
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('pw2NightShiftRate').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			placeholder="PW3 Night Shift Rate Rate"
			formControlName="pw3NightShiftRate"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="form.get('pw3NightShiftRate').hasError('isNotNumeric')"
		>
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('pw3NightShiftRate').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
</div>
